import axios from 'axios';

import { authAxios } from '@/common/axios';
import runtimeConfig from '@/common/runtime-config';

import mockApi from './mock';

const useMocks = process.env.VUE_APP_USE_MOCKS === 'true';

const oidcAxios = axios.create({
  baseURL: runtimeConfig.apiAuthUrl,
  withCredentials: true,
});

const authApi = {
  exchange(payload) {
    return oidcAxios.post('/api/auth/exchange', payload);
  },
  refresh() {
    return oidcAxios.post('/api/auth/refresh', null, {
      params: { clientId: runtimeConfig.oidc.clientId },
    });
  },
  getProfileData() {
    return authAxios.get('/api/user/profile');
  },
};

export default useMocks ? mockApi : authApi;
